import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Filter } from '../filter.model';

@Component({
  selector: 'app-filter-input',
  templateUrl: './filter-input.component.html',
  styleUrls: ['./filter-input.component.scss']
})
export class FilterInputComponent implements OnInit {
  @Input() filter: Filter;
  @Input() filterForm: UntypedFormGroup;
  @Output() filterChange = new EventEmitter<any>();

  constructor(
    private fb: UntypedFormBuilder,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    const val = this.filter.selected?.id || '';
    this.filterForm = this.fb.group({
      inputData:  new UntypedFormControl(val, Validators.required)
    })
  }

  onSubmit(){
    if (this.filterForm.valid){
      const val = this.filterForm.controls.inputData.value;
      const filterName = this.translateService.instant(this.filter.name);

      this.filter.selected = {
        id: val,
        label: val,
        value: val,
        display : `${filterName}: ${val}`
      }
      this.filterChange.emit(this.filter);
    }
  }

}
